<template>
  <v-dialog v-model="notifopen" width="800px" persistent>
    <v-card class="elevation-0 rounded-0">
      <v-toolbar class="elevation-0 rounded-0" dense color="#f7f7f7">
        Quota Notification Configuration
        <v-spacer></v-spacer>
        <v-btn small class="elevation-0 rounded-0" icon @click="removeNotif()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-toolbar v-if="notifData" class="elevation-0 rounded-0" dense>
        <v-toolbar-subtitle>{{ notifData.vessel_pt }}</v-toolbar-subtitle>

        <v-spacer></v-spacer>
      </v-toolbar>
      <v-divider v-if="notifData"></v-divider>
      <v-container style="margin-top: 0" v-if="!notifmodal" fill-height fluid>
        <v-row align="center" justify="center">
          <v-col
            ><img
              alt="Navplus logo"
              width="70px"
              :src="loadernavplus"
              class="justify-center"
          /></v-col>
        </v-row>
      </v-container>
      <v-card-text v-if="notifmodal" class="mt-10">
        <v-container style="margin-top: 0" v-if="!notifData" fill-height fluid>
          <v-row align="center" justify="center">
            <v-col
              ><img
                alt="Navplus logo"
                width="70px"
                :src="loadernavplus"
                class="justify-center"
            /></v-col>
          </v-row>
        </v-container>

        <div v-if="notifData">
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                class="elevation-0 rounded-0"
                v-model="notifData.batas"
                label="Limit Threshold"
                hint="*dipisahkan menggunakan spasi E.g. 45 70 80 100"
                @input="checkdata('batas')"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-switch
                @change="checkdata('enabled')"
                inset
                v-model="notifData.enabled"
                :label="`Enabled`"
              ></v-switch>
            </v-col>
            <v-col style="margin-top: -20px" cols="12">
              <v-textarea
                @input="checkdata('emails')"
                class="elevation-0 rounded-0"
                name="input-7-1"
                v-model="notifData.emails"
                label="Email Notification"
                outlined
                auto-grow
                placeholder="maritimeit@waruna-group.com"
                value="maritimeit@waruna-group.com"
                hint="*dipisahkan menggunakan spasi
                   E.g. noc@sailink.co.id skyreach@sailink.co.id"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-btn
            @click="notifDataPost()"
            :disabled="changes_ ? false : true"
            color="primary"
            class="elevation-0 rounded-0"
            small
            block
          >
            Update Quota Notification
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "../../utils/axios";
import $ from "jquery";
export default {
  props:['notif_id'],
  data() {
    return {
      notifmodal: null,
      change: false,
      loadernavplus: require("@/assets/img/load100new.gif"),
    };
  },
  methods: {
    ...mapActions(["fetchNotif", "removeNotif", "fetchNotif", "notifPost"]),
    checkdata(statis) {
      // console.log(this.notifmodal[statis]);
      // console.log(this.notifData[statis]);
      if (this.notifmodal[statis] == this.notifData[statis]) {
        this.change = false;
      } else {
        this.change = true;
      }
    },
    async notifDataPost() {
      this.change = false;
      const data = {
        id: this.notifID,
        enabled: this.notifData.enabled,
        batas: this.notifData.batas,
        emails: this.notifData.emails,
        token: localStorage.getItem("token"),
      };
      this.notifPost(data);
    },

    async notifFetchStatic() {
      console.log(this.notif_id);
      try {
        const response = await axios.get(
          "/api/v1/navplus/email/limit/" + this.notif_id,
          {
            headers: {
              Authorization: "Bearer" + localStorage.getItem("token"),
            },
          }
        );

        console.log(response);
        this.notifmodal = response.data.data;
      } catch (e) {
        console.log(e);
      }
    },
  },

  mounted() {
    console.log(this.notif_id)
    this.notifFetchStatic();
  },

  computed: {
    ...mapGetters(["notifopen", "notifData", "notifID"]),
    changes_() {
      return this.change;
    },
  },
};
</script>

<style lang="scss" scoped></style>
